import Chip from '@mui/material/Chip'
import Grid from '@mui/material/Grid2'
import { isUndefined } from 'lodash'
import moment from 'moment/moment'
import { FC } from 'react'

const TODAY_DD_MMMM = moment().format('DD MMMM')

type Props = {
    createdAt: string
    createdAtLast?: string
}

export const DateChip: FC<Props> = ({ createdAt, createdAtLast }) => {
    const created_DD_MMMM = moment(createdAt).format('DD MMMM')
    const created_last_DD_MMMM = moment(createdAtLast).format('DD MMMM')

    let createdBuff = undefined

    if (isUndefined(createdAtLast)) {
        createdBuff = created_DD_MMMM === TODAY_DD_MMMM ? 'Сегодня' : created_DD_MMMM
    } else {
        if (created_DD_MMMM === created_last_DD_MMMM) {
            createdBuff = null
        } else {
            createdBuff = created_DD_MMMM === TODAY_DD_MMMM ? 'Сегодня' : created_DD_MMMM
        }
    }

    return (
        <>
            {createdBuff && (
                <Grid textAlign="center" container display="flex">
                    <Chip
                        label={
                            createdBuff === 'Сегодня'
                                ? 'Сегодня'
                                : moment(createdBuff, 'DD MMMM').format('DD MMMM')
                        }
                        variant="outlined"
                        sx={{
                            margin: '0 auto',
                            fontSize: '12px',
                            height: '24px',
                            padding: '8px 12px',
                            borderColor: '#E7E8EE',
                            color: '#5E626E',
                        }}
                    />
                </Grid>
            )}
        </>
    )
}
